<div class="modal fade" bsModal #cancelPayment="bs-modal" [config]="modalConfig" id="cancelPayment" tabindex="-1" role="dialog" aria-hidden="true" style="z-index: 1000000;">
  <div class="modal-dialog modal-dialog-centered modal-md">
    <div class="modal-content" style="width: 500px">
      <div class="modal-header">
        <h5 class="modal-title">Confirm</h5>
      </div>
      <div class="modal-body ptb24">
        <p class="mb-0">Transaction is in Progress. Please do not leave the page!</p>
      </div>
      <div class="modal-footer">
        <button class="btn btn-outline-primary mr-3" type="button" (click)="cancelPayment.hide()">OK</button>
      </div>
    </div>
  </div>
</div>